import { SearchBox } from "../../../common/SearchBox";
import { SearchBoxWrapper } from "../MessagePanel.style";
import { useTranslation } from "hhn-commons";
import { IForwardToLoadingStates } from "@home-health-notify/domain";

interface ForwardToSearchProps {
  onSearchTextChange: (searchText: string) => void;
  onSearchClear: () => void;
  searchText: string;
  isLoading: IForwardToLoadingStates;
  autoFocus?: boolean;
  supportsMrnSearch?: boolean;
}

function ForwardToSearch({
  onSearchTextChange,
  onSearchClear,
  searchText,
  isLoading,
  autoFocus,
  supportsMrnSearch,
}: ForwardToSearchProps) {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });

  return (
    <SearchBoxWrapper>
      <SearchBox
        placeholderLabel={
          supportsMrnSearch ? tNs("forwardTo.searchByNameOrMrn") : tNs("search")
        }
        searchText={searchText}
        onSearchTextChange={onSearchTextChange}
        onSearchClear={onSearchClear}
        isLoading={isLoading.isSearchLoading}
        autoFocus={autoFocus}
      />
    </SearchBoxWrapper>
  );
}

export default ForwardToSearch;
